import { render, staticRenderFns } from "./VpsPendingApprovalLeadModal.vue?vue&type=template&id=69f6a16c"
import script from "./VpsPendingApprovalLeadModal.vue?vue&type=script&lang=js"
export * from "./VpsPendingApprovalLeadModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports